import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import moment from 'moment';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { removeConflictedAvailability } from '../../../../redux/availability/actions/availability.action';
import { AppDispatch } from '../../../../redux/rootReducer';
import styles from '../AvailabilityConflict/AvailabilityConflict.module.css';

interface DataProps {
    appointments: string[] | null;
    availabilityId: string;
    endDate: string;
    locationName: string;
    startDate: string;
    unitId: string;
    unitName: string;
}

interface AddAvailabilityObjProps {
    closingTime: string;
    endDate: string;
    locationId: string;
    locationName: string;
    locker: number;
    openingTime: string;
    startDate: string;
    unitId: string;
    unitName: string;
}

interface ConflictDelete {
    data: DataProps[];
    setShowConflictDelete: Dispatch<SetStateAction<boolean>>;
    addAvailabilityObj: AddAvailabilityObjProps;
    setShowConfirm: Dispatch<SetStateAction<boolean>>;
}

const ConflictDelete = ({ data, setShowConflictDelete, addAvailabilityObj, setShowConfirm }: ConflictDelete) => {
    const dispatch: AppDispatch = useDispatch();

    const [conflictedObj, setConflictedObj] = useState({
        conflictedData: [],
        locationName: '',
        unitName: '',
        availabilityId: '',
    });

    useEffect(() => {
        data?.map((el: DataProps) => {
            setConflictedObj((prevState: AnyIfEmpty<object>) => {
                return {
                    ...prevState,
                    conflictedData: el.appointments,
                    locationName: el.locationName,
                    unitName: el.unitName,
                    availabilityId: el.availabilityId,
                };
            });
        });
    }, [data]);

    const deleteConflictHandler = () => {
        const conflictedAvailabilityObj = {
            locationId: addAvailabilityObj.locationId,
            locker: addAvailabilityObj.locker,
            startDate: addAvailabilityObj.startDate,
            endDate: addAvailabilityObj.endDate,
            openingTime: addAvailabilityObj.openingTime,
            closingTime: addAvailabilityObj.closingTime,
        };
        dispatch(removeConflictedAvailability(conflictedObj.availabilityId, conflictedAvailabilityObj));
        setShowConflictDelete(false);
        setShowConfirm(true);
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Are you sure want to delete this?</h2>
            </div>
            <div className={styles.body}>
                {!conflictedObj?.conflictedData?.length ? (
                    <p className={styles.noData}>There are no appointments scheduled during the availability to be deleted.</p>
                ) : (
                    <>
                        <p>Upcoming Appointments for this Availability</p>
                        <div className={styles.tableWrapper}>
                            <table className={styles.conflictData}>
                                <tr className={styles.tableHead}>
                                    <th>Property</th>
                                    <th>Unit Name</th>
                                    <th>Date</th>
                                </tr>
                                {conflictedObj?.conflictedData &&
                                    conflictedObj?.conflictedData?.map((conflicted, index) => (
                                        <tr key={index}>
                                            <td>
                                                <p>{conflictedObj?.locationName}</p>
                                            </td>
                                            <td>
                                                <p>{conflictedObj?.unitName}</p>
                                            </td>
                                            <td>
                                                <p>{moment(conflicted).locale('en').format('Do MMM YYYY')}</p>
                                            </td>
                                        </tr>
                                    ))}
                            </table>
                        </div>
                    </>
                )}
                <div className={styles.btnWrapper}>
                    <button onClick={deleteConflictHandler} type="button" className={styles.btnDelete}>
                        Delete
                    </button>
                    <button
                        onClick={() => {
                            setShowConflictDelete(false);
                            setShowConfirm(true);
                        }}
                        className={styles.btnCancel}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConflictDelete;
